<script>
import appConfig from "@/app.config";
import axios from 'axios';
import Layout from "@/layouts/main";
import Navbar from "@/components/navbar";
import Scrollspy from 'vue2-scrollspy';
import { EventBus } from "@/event-bus";
import AOS from 'aos';
import "aos/dist/aos.css";
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  components: {
    Layout,
    Navbar,
    Scrollspy,
    VueEasyLightbox,
  },
  data() {
    return {
      appConfig: appConfig,
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      timelineSection: 0,
      timelineTitles: [],
      visible: false,
      currentIndex: 0,
      lightboximgs: [],
    }
  },
  computed: {
  },
  metaInfo() {
    return {
      title: '연혁 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터가 지나온 발자취를 확인하세요. 센터의 역사와 주요 활동을 연혁으로 확인할 수 있습니다.'
        },
        {
          property: 'og:title',
          content: '연혁 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터가 지나온 발자취를 확인하세요. 센터의 역사와 주요 활동을 연혁으로 확인할 수 있습니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '연혁 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터가 지나온 발자취를 확인하세요. 센터의 역사와 주요 활동을 연혁으로 확인할 수 있습니다.'
        }
      ]
    }
  },
  mounted() {
    // AOS 초기화
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  },
  created() {
    this.first()
    this.getHistory()
    EventBus.$on("menu-timeline", (val)=> {
      if (val=='listRefresh') {
        this.getHistory();
      }
    });
  },
  methods: {
    // 홈페이지 기본정보
    first() {
      // 로그인 사용자 정보
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
      this.boardInfo = this.$store.getters.getWebSiteInfoBoard
    },
    // 링크 걸려있는 히스토리면 링크 새탭으로열기
    isLink(val) {
      if (val.linkUrl) {
        //this.$router.push(val.link)
        var win = window.open(val.linkUrl, '_blank');
        win.focus();
      }
    },
    // 연혁 가져오자
    async getHistory() {
      await axios({
        method: 'POST',
        url: appConfig.fastapi + '/history/getHistory',
        data: {
          "work": "normal",
        },
      })
      .then((response) => {
        if (response.data.historyData) {
          this.timelineTitles = response.data.historyData
        } else {
          this.$notify({ type: 'success', duration:2000, 'title': '실패', text: response.data.message})
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
      })
    },
    // 연혁 추가하기 & 수정하기
    modalTimeline(val1, val2) {
      if (val1=='timelineEdit') {
        // 연혁 수정이면 useEnd true로 알려줘야지
        if (val2.end =='' || val2.end == null) {
          val2.useEnd = false
        } else {
          val2.useEnd = true
        }
      }
      // timelineAdd , timelineEdit
      this.$store.commit('setModal_lgVal', val2); // store.js 로 보내주자
      this.$store.commit('setModal_lgWorker', val1); // store.js 로 보내주자
      this.$root.$emit('bv::toggle::modal', 'modal_lg'); // 모달 오픈
    },
    imgThum(val1, val2) {
      if (val1 == 'thumb') {
        return appConfig.fileserver+"/historyThum/"+val2;
      } else {
        return appConfig.fileserver+"/historyImages/"+val2;
      }
    },
    // file_json에서 썸네일용 이미지 리스트 뽑아오기
    thumbListFromFileJson(fileJson) {
      if (!fileJson) return [];

      let data = fileJson;
      // 문자열로 넘어오면 JSON 파싱 시도
      if (typeof fileJson === 'string') {
        try {
          data = JSON.parse(fileJson);
        } catch (e) {
          return [];
        }
      }

      if (!Array.isArray(data)) return [];

      // [{ file: "...", ... }] 형태일 때 (파일명 필드 사용)
      if (data.length && typeof data[0] === 'object') {
        return data
          .filter(f => f && (f.file || f.url))
          .map(f => f.file || f.url);
      }

      // ["...", "..."] 문자열 배열일 때 (파일명 배열 그대로)
      return data;
    },
    // 썸네일을 배열 형태로 반환 (문자열이면 1개짜리 배열로 변환)
    thumbList(thum) {
      if (!thum) return [];
      if (Array.isArray(thum)) return thum;
      return [thum];
    },
    imgThumClick(file_json, index) {
      this.lightboximgs = this.getOriginalImageUrl(file_json);
      this.currentIndex = index;
      this.visible = true;
    },
    getOriginalImageUrl(file_json) {
      return file_json.map(item => appConfig.fileserver+"/historyImages/"+item);
    },
  },
}
</script>

<template>
  <Layout>
    <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
    <Navbar :nav-light="true" />

    <!-- 이미지 크게 -->
    <vue-easy-lightbox :visible="visible" :index="currentIndex" :imgs="lightboximgs" scrollDisabled='false' @hide="visible = false"></vue-easy-lightbox>

    <section class="bg-half-2 navwave d-table w-100">
      <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
      <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
      <div class="bread-overlay-2 opacity-5"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <div class="title text-white title-dark">
                <h3>연혁</h3>
                <h4>대구여성인권센터가 지나온 발자취</h4>
              </div>
              <div class="page-next">
                <nav aria-label="breadcrumb" class="d-inline-block">
                  <ul class="breadcrumb bg-white rounded shadow mb-0">
                    <li class="breadcrumb-item">
                      <router-link to="/">홈</router-link>
                    </li>
                    <li class="breadcrumb-item "><a href="#">센터</a></li>
                    <li class="breadcrumb-item active" aria-current="page">연혁</li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 둥글게 처리 -->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <!-- 연혁 timeline -->
    <section class="">

      <div class="container mt-100 mt-60">

        <!-- 관리자라면 -->
        <div v-if="login.level > 97" class="mb-2">
          <b-button @click="modalTimeline('timelineAdd', '')" class="btn btn-block btn-md btn-soft-blue">
            <i class="mdi mdi-book-edit mr-1"></i>연혁 추가
          </b-button>
        </div>

        <div v-if="timelineTitles.length > 0" class="row">
          
          <!-- 연혁 연도 -->
          <div class="col-2 timeline-mobile-bg">
            <div class="section-title sticky-bar position-sticky">
              <div class="timeline-menu" v-scroll-spy-active="{class: 'timeline-customActive'}" v-scroll-spy-link>
                <div v-for="item in timelineTitles" :key="item.year" class="timeline-menu-item text-center">
                  <a><div class="timeline-menu-text">{{ item.year }}</div></a>
                </div>
              </div>
            </div>
          </div>

          <!-- 연혁 리스트 -->
          <div class="timeline-main mb-4" v-scroll-spy="{data: 'timelineSection', offset: 75, time: 100, steps: 10}">

            <!-- 연도별 루프 -->
            <div v-for="item in timelineTitles" :key="item.year" class="timeline-page pt-2 position-relative">
              <div class="timeline-item">
                <div class="row">
                  
                  <!-- 연도 나오는 부분 -->
                  <div class="col-12 mt-4">
                    <div :id="item.year" :name="item.year" class="duration date-label-left p-2 position-relative ">
                      <h3 class="text-bold text-muted">{{ item.year }}년</h3>
                    </div>
                  </div>
                  
                  <!-- this 연도의 내용 루프 -->
                  <div data-aos="fade-up" v-for="i in item.thisData" :key="i.idx" class="col-xl-12 mb-3">

                    <!-- 관리자라면 수정버튼 나오게 -->
                    <div v-if="login.level > 97" class="history-edit ">
                      <b-button @click="modalTimeline('timelineEdit', i)" class="btn-sm btn-block p-0" 
                        :class="{'btn-blue': thumbListFromFileJson(i.file_json).length > 0, 'btn-danger': thumbListFromFileJson(i.file_json).length == 0}">
                        <i class="mdi mdi-pencil font-size-13"></i>
                      </b-button>
                    </div>

                    <div class="d-flex flex-column flex-md-row align-items-start timeline-content m-2 ml-2">
                      
                      <!-- 썸네일 이미지 있으면 (file_json 기준으로 여러 개 겹쳐서 표시) -->
                      <div v-if="thumbListFromFileJson(i.file_json).length" class="work-container work-modern position-relative d-block">
                        <div class="history-thum rounded text-center">
                          <div
                            v-for="(thumb, index) in thumbListFromFileJson(i.file_json)"
                            :key="index"
                            class="history-thum-item cursor-pointers"
                            @click="imgThumClick(i.file_json, index)"
                            :style="{ left: (index * 16) + 'px', zIndex: (10 - index) }"
                          >
                            <img
                              :src="imgThum('thumb', thumb)"
                              class="avatar avatar-small avatar-tiny rounded-circle shadow d-block mx-auto border-2"
                              alt="history thumbnail"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </div>

                      <!-- file_json 없는데 thum 있으면 -->
                      <div v-else-if="i.thum" class="work-container work-modern position-relative d-block overflow-hidden">
                        <div class="history-thum rounded text-center">
                          <img
                            :src="imgThum('thumb', i.thum)"
                            class="avatar avatar-small avatar-tiny shadow d-block mx-auto border-2"
                            alt="history thumbnail"
                            loading="lazy"
                          />
                        </div>
                      </div>

                      <!-- file_json 없는데  thum도 없으면 -->
                      <div v-else class="work-container work-modern position-relative d-block overflow-hidden">
                        <div class="history-thum rounded text-center">
                        </div>
                      </div>



                      <!-- 연혁 내용 -->
                      <div
                        @click="isLink(i)"
                        class="content ml-0 ml-md-2 p-3 rounded border position-relative text-dark flex-grow-1"
                        :class="{'cursor-pointers':i.linkUrl != '' && i.linkUrl !=null}"
                        style="word-break: break-all; overflow-wrap: anywhere;"
                      >
                        <div class="text-bold text-muted font-size-12">
                          <i class="mdi mdi-clock-outline font-size-10"></i>
                          {{ i.start }}
                          <!-- 종료날짜 있으면 -->
                          <span v-if="i.end" class="">
                            <span class="text-warning font-size-10 mr-1 ml-1"> ~ </span>
                            <!-- 시작과 끝이 같으면 뒤에꺼 안나오게 (기한의 끝이없단 뜻)-->
                            <span v-if="i.start==i.end"> </span>
                            <span v-else>{{ i.end }}</span>
                          </span>
                        </div>
                        <!-- 제목 -->
                        <div class="font-size-13 mb-0 text-bold" :class="{'text-info':i.linkUrl != '' && i.linkUrl !=null}">
                          {{ i.contents }}
                          <!-- 링크 있으면 아이콘 -->
                          <span v-if="i.linkUrl != '' && i.linkUrl !=null" class="rounded border ml-1">
                            <!-- 새탭여는 아이콘-->
                            <i class="mdi mdi-open-in-new text-primary font-size-15"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        
      </div>
    </section>
  </Layout>
</template>